import { useMutation } from '@tanstack/react-query';
import type { ExportarDocumentosTurboPayload, ExportarDocumentosTurboResponse } from '../types';
import { exportarDocumentosTurboApi } from '../api/ExportarDocumentosTurboApi';

export function useExportarDocumentosTurbo() {
  return useMutation<ExportarDocumentosTurboResponse, Error, ExportarDocumentosTurboPayload>({
    mutationFn: exportarDocumentosTurboApi,
  });
}
